// deps
import { AriaHidden } from "@swiggy-private/core-ui";
import styled, { css, keyframes } from "styled-components";
import { getCornerRadius } from "@swiggy-private/dls-web-common/dist/components/themes/CornerRadiusMapping/mapping";

interface AddCakeMessagePillContainerProps {
    hideAnimation?: boolean;
    isEditState?: boolean;
}

export const AddCakeMessagePillContainer = styled.button<AddCakeMessagePillContainerProps>`
    ${({ theme, isEditState, hideAnimation }) => {
        const glowAnimation = keyframes`

            0% {
                box-shadow: 0 0 4px #FFCB8F;
              
            }
                 25% {
                box-shadow: 0 0 8px #FFCB8F;
              
            }
            
            50% {
                box-shadow: 0 0 4px #FFCB8F;
            }
           75% {
                box-shadow: 0 0 8px #FFCB8F;
            }
            
            100% {
                box-shadow: 0 0 0px #FFCB8F;
                
            }
        `;

        return css`
    ${theme.typography["V2.body2.neutral.medium"]}
    background: ${
        isEditState
            ? theme.colors[theme.colorMode].background_Secondary
            : theme.colors[theme.colorMode].background_Primary
    };
    display: flex;
    align-items: center;
    border-radius: ${getCornerRadius(theme, "xSmall")};
    position: relative;
    z-index: 0;
    padding: ${theme.spacing.xSmall} ${theme.spacing.small} ${theme.spacing.xSmall} ${theme.spacing.xSmall};
    border: 1px solid ${theme.colors[theme.colorMode].divider};
    animation: ${
        hideAnimation || isEditState
            ? "none"
            : css`
                  ${glowAnimation} 5s ease-in-out
              `
    };
    };
  `;
    }}
`;
export const CakeText = styled.div({
    marginTop: "1px",
});

export const IconStyled = styled(AriaHidden)({
    marginRight: "6px",
    height: "18px",
    width: "18px",
    position: "relative",
});
